// https://github.com/diegohaz/arc/wiki/Example-redux-modules#entities
import { schema } from 'normalizr';

export const cms = new schema.Entity('cms');
export const settings = new schema.Entity('settings');

export const guests = new schema.Entity('guests');
export const vehicles = new schema.Entity('vehicles');
export const cabins = new schema.Entity('cabins');
export const departures = new schema.Entity('departures');

export const reservations = new schema.Entity('reservations', {
  cabins: [cabins],
  guests: [guests],
  vehicles: [vehicles],
  departures: [departures],
}, {
  idAttribute: 'reservationCode',
});



// WEBPACK FOOTER //
// ./src/store/entities/schemas.js